var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 5.5,
  width: 37,
  height: 5.5,
  fill: "#dfe6ec"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m11 5.5v5.5m22 -5.5v5.5",
  fill: "none",
  stroke: "#b4bfc6",
  strokeWidth: 1
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 5.5,
  width: 8,
  height: 5.5,
  fill: "#5c6870"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 10.5,
  width: 8.5,
  height: 5.5,
  rx: 0.5,
  fill: "#eef1f5",
  transform: "rotate(18 18 11)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m13.5 36 5.5-22.5",
  fill: "none",
  stroke: "#e8923a",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m24.5 36-4.5-22.5",
  fill: "none",
  stroke: "#d0731f",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m15 30h8.3",
  fill: "none",
  stroke: "#e8923a",
  strokeWidth: 1.6,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m16.2 25h6.2",
  fill: "none",
  stroke: "#e8923a",
  strokeWidth: 1.6,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m17.4 20h4.1",
  fill: "none",
  stroke: "#e8923a",
  strokeWidth: 1.6,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 36,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

function SvgCeilingRepairs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeilingRepairs);
export default __webpack_public_path__ + "static/media/ceiling-repairs.fa76dc98a20d9136fe851111fa1086c7.svg";
export { ForwardRef as ReactComponent };